import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const HomeContentCtx = createContext(null);

const FALLBACK = {
  hero_eyebrow: "Atelier Edition · MMXXVI",
  hero_headline: "Quietly\nExtraordinary.",
  hero_subtagline: "Hand-finished fine jewelry, made by craft and worn by character.",
  hero_image: "https://images.unsplash.com/photo-1613966561243-c6959a886009?crop=entropy&cs=srgb&fm=jpg&q=85",
  hero_cta_label: "Shop the Collection",
  hero_cta_link: "/shop",
  hero_secondary_label: "The Journal",
  hero_secondary_link: "/journal",
  marquee_items: [
    "Hand-finished in London",
    "Free UK delivery over £100",
    "30-day complimentary returns",
    "Lifetime aftercare",
    "Ethically sourced",
  ],
  category_section_eyebrow: "Explore",
  category_section_title: "By Category",
  category_tiles: [
    { slug: "rings", label: "Rings", image: "" },
    { slug: "necklaces", label: "Necklaces", image: "" },
    { slug: "earrings", label: "Earrings", image: "" },
    { slug: "bracelets", label: "Bracelets", image: "" },
  ],
  lifestyle_image: "",
  lifestyle_eyebrow: "The Atelier",
  lifestyle_headline: "Worn slowly. Kept always.",
  lifestyle_body: "Each piece is sketched, modelled and finished by hand at our Hatton Garden studio — designed to outlast trends and become part of your story.",
  featured_eyebrow: "The Edit",
  featured_title: "Atelier Picks",
  ai_eyebrow: "AI Stylist",
  ai_title: "Curated for you",
  ai_body: "",
  ai_enabled: true,
};

export function HomeContentProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);

  const refresh = async () => {
    try {
      const { data } = await api.get("/home-content");
      setContent({ ...FALLBACK, ...data });
    } catch { /* keep fallback */ }
  };

  useEffect(() => { refresh(); }, []);

  const update = async (patch) => {
    const { data } = await api.patch("/admin/home-content", patch);
    setContent({ ...FALLBACK, ...data });
    return data;
  };

  return <HomeContentCtx.Provider value={{ content, update, refresh }}>{children}</HomeContentCtx.Provider>;
}

export const useHomeContent = () => useContext(HomeContentCtx) || { content: FALLBACK, update: async () => {}, refresh: async () => {} };
